import { useLayoutPreference } from '@/components/InvoiceReportDetailDrawer/hooks/useLayoutPreference';
import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';

export const TransactionsLayouts = {
  table: 'table',
  card: 'card',
} as const;

export type TransactionsLayout =
  (typeof TransactionsLayouts)[keyof typeof TransactionsLayouts];

const DEFAULT_LAYOUT: TransactionsLayout = TransactionsLayouts.table;

const STORAGE_KEY = 'paymentDetailDrawerTransactionsLayout:v1';

/**
 * Tracks the 支払明細 layout choice, persisted per user in localStorage
 * (NA-5531): the last-used layout is restored the next time the user
 * reopens the drawer or reloads the page. Users who never changed the
 * layout keep seeing the default (`table`).
 *
 * Gated by the `approval-drawer-view-optimization` flag. The clamp lives here
 * rather than at the call site so a caller cannot forget it: with the flag off
 * the layout is always `table`, even if the user switched to `card` earlier in
 * the same session (or a previous one) while the flag was on.
 */
export const useTransactionsLayout = () => {
  const isLayoutSwitchEnabled = useApprovalDrawerViewOptimizationFlag();

  const { layout, setLayout } = useLayoutPreference<TransactionsLayout>({
    storageKey: STORAGE_KEY,
    defaultLayout: DEFAULT_LAYOUT,
    validValues: Object.values(TransactionsLayouts),
    isEnabled: isLayoutSwitchEnabled,
  });

  return {
    layout,
    setLayout,
    isLayoutSwitchEnabled,
  };
};
